import React, { memo, Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';

const SvgFormat = props => {
  const { type, ...restProps } = props;
  const svgType = upperFirst(camelCase(type));
  const SvgComponents = lazy(() => import(`~components/svgs/${svgType}`));

  return (
    <Suspense fallback="">
      <SvgComponents {...restProps} />
    </Suspense>
  );
};

SvgFormat.propTypes = {
  type: PropTypes.string.isRequired,
};

export default memo(SvgFormat);
